import React, { useState } from 'react'
import './slideAwards.scss'

import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import award1 from '../../../assets/images/awards/award-1.png'
import award2 from '../../../assets/images/awards/award-2.png'
import award3 from '../../../assets/images/awards/award-3.png'

import award1PE from '../../../assets/images/awards/award-1-pe.png'
import award2PE from '../../../assets/images/awards/award-2-pe.png'
import award3PE from '../../../assets/images/awards/award-3-pe.png'

import award1CL from '../../../assets/images/awards/award-1-cl.png'
import award2CL from '../../../assets/images/awards/award-2-cl.png'

import useMediaQuery from '../../../utils/useMediaQuery'

import arrow from '../../../assets/images/awards/arrow.svg'
import { LOCALE } from '../../../constants/activity-constants'

const ArrowSlide = ({ direction, onClick }) => {
  return (
    <button className={`f-arrow-slide ${direction}`} onClick={onClick}>
      <img src={arrow} alt="flecha slide" />
    </button>
  )
}

const SlideAwards = ({ section }) => {
  const [actualSlide, setActualSlide] = useState(0)
  const isMobile = useMediaQuery()

  const awardsByLocale = {
    'es-CO': [
      {
        img: award1,
        title: 'Bono de TENNIS por $100MIL',
        description: (
          <>
            ¿Te gusta la moda? ¡A Nosotras también! Por eso con este bono podrás
            <b> actualizar tu closet</b> con la increíble ropa de Tennis.
          </>
        ),
        winnersOfChanllenge: '10',
      },
      {
        img: award2,
        title: 'Kit de maquillaje Prebel',
        description: (
          <>
            Vive tu momento Euphoria y hazte los mejores looks con este
            increíble kit por <b>un valor de $100.000 COP.</b> ¡Serán 10
            ganadoras!
          </>
        ),
        winnersOfChanllenge: '10',
      },
      {
        img: award3,
        title: 'Kit de lettering de TOY',
        description: (
          <>
            Programa de lettering completo para
            <b> aprender a dibujar letras hermosas.</b> ¡Contiene plantillas,
            ejercicios y más!
          </>
        ),
        winnersOfChanllenge: '10',
      },
    ],
    'es-PE': [
      {
        img: award1PE,
        title: 'Altavoz Philips',
        description: (
          <>
            Escucha los hits del momento donde quieras con este Altavoz
            Inalámbrico Portátil Philips.
          </>
        ),
        winnersOfChanllenge: '3',
      },
      {
        img: award2PE,
        title: 'Kit de maquillaje Maybelline',
        description: (
          <>
            Hazte los mejores looks y siéntete increíble con este hermoso{' '}
            <b>kit de maquillaje Maybelline.</b>
          </>
        ),
        winnersOfChanllenge: '3',
      },
      {
        img: award3PE,
        title: 'vale Saga Falabella',
        description: (
          <>
            Vale de descuento por 100 soles{' '}
            <b> para que compres lo que quieras en Saga Falabella.</b>{' '}
            ¡Disfruuuuta!{' '}
          </>
        ),
        winnersOfChanllenge: '3',
      },
    ],
    'es-CL': [
      {
        img: award1CL,
        title: 'Parlante Bluetooth Sony',
        description: (
          <>
            Escucha los hits del momento donde quieras con este{' '}
            <b>Parlante Bluetooth Sony.</b>
          </>
        ),
        winnersOfChanllenge: '3',
      },
      {
        img: award2CL,
        title: 'Gift Card',
        description: (
          <>
            <b>Gift Card (Bienestar) de $25.990 de GetawayBox.</b> ¡Disfruuuuta!
          </>
        ),
        winnersOfChanllenge: '5',
      },
    ],
  }

  const awards = awardsByLocale[LOCALE] || awardsByLocale['es-CO']

  const awardsPosition = {
    0: 1,
    1: 2,
    2: 3,
  }

  const settingsSlider = {
    dots: false,
    infinite: true,
    nextArrow:
      LOCALE === 'es-CL' ? (
        isMobile && <ArrowSlide direction="right" />
      ) : (
        <ArrowSlide direction="right" />
      ),
    prevArrow:
      LOCALE === 'es-CL' ? (
        isMobile && <ArrowSlide direction="left" />
      ) : (
        <ArrowSlide direction="left" />
      ),
    speed: 500,
    slidesToShow: LOCALE === 'es-CL' ? 1.99 : 2.99,
    slidesToScroll: LOCALE === 'es-CL' ? 2 : 1,
    className: LOCALE !== 'es-CL' && 'center',
    centerMode: LOCALE !== 'es-CL' && true,
    centerPadding: LOCALE !== 'es-CL' && '10px',
    beforeChange: (current, next) => {
      setActualSlide(next)
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          dots: true,
        },
      },
    ],
  }

  return (
    <section className="f-slide-awards">
      <div className="f-slide-awards__wrapper">
        <p className="f-slide-awards__subtitle">
          Cada reto tendrá también un premio
        </p>

        {LOCALE !== 'es-CL' && !(isMobile && section === 'awards') && (
          <h3 className="f-slide-awards__title">
            PREMIO RETO {awardsPosition[actualSlide]}
          </h3>
        )}

        <div className="f-slide-awards__items">
          {isMobile && section === 'awards' ? (
            <>
              {awards.map((item, i) => {
                return (
                  <div
                    key={`item-${i + 1}`}
                    className={`f-slide-awards__item mobile-awards`}
                  >
                    <h3 className="f-slide-awards__title">
                      PREMIO RETO {i + 1}
                    </h3>

                    <div className="f-slide-awards__item__img">
                      <img src={item.img} />
                    </div>
                    <h4 className="f-slide-awards__item__title">
                      {item.title}
                    </h4>
                    <div className="f-slide-awards__item__description">
                      <p>{item.description}</p>
                    </div>
                  </div>
                )
              })}
            </>
          ) : (
            <Slider {...settingsSlider}>
              {awards.map((item, i) => {
                return (
                  <div
                    key={`item-${i + 1}`}
                    className={`f-slide-awards__item ${
                      LOCALE === 'es-CL' && '--isCL'
                    }`}
                  >
                    {LOCALE === 'es-CL' && !isMobile && (
                      <h3 className="f-slide-awards__title --mb-20">
                        {`PREMIO RETO ${i + 1}`}
                      </h3>
                    )}

                    <div className="f-slide-awards__item__img">
                      <img src={item.img} />
                    </div>
                    <h4 className="f-slide-awards__item__title">
                      {item.title}
                    </h4>
                    <div className="f-slide-awards__item__description">
                      <p>{item.description}</p>
                      <span>{item.winnersOfChanllenge} GANADORAS</span>
                    </div>
                  </div>
                )
              })}
            </Slider>
          )}
        </div>
      </div>
    </section>
  )
}

export default SlideAwards
